import React, { useEffect } from 'react';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { channels } from 'shared/constants';

import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import WarningIcon from '@mui/icons-material/Warning';
import ButtonReauthorization from 'pages/Onboarding/StepTwo/ButtonReauthorization';
import ButtonAuthorization from 'pages/Onboarding/StepTwo/ButtonAuthorization';

interface FormValues {
  store_name: string;
  store_handle: string;
}

interface ShoplineConnectProps {
  chData?: {
    store_name: string;
    store_handle: string;
  };
  isConnected?: boolean;
}

const ShoplineContent: React.FunctionComponent<ShoplineConnectProps> = ({ chData, isConnected = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    console.log(data);
  };

  useEffect(() => {
    if (isConnected && chData) {
      // Set the store name and handle from the connected data
      setValue('store_name', chData.store_name);
      setValue('store_handle', chData.store_handle);
    }
  }, [isConnected, chData, setValue]);

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.SHOPLINE} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="shopline_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            wide={true}
            label={<Label>Nama Toko</Label>}
            input={
              <Input isError={false} type={'text'} placeholder={'Masukkan Nama Toko'} disabled={isConnected} {...register('store_name')} />
            }
          />
          <InputGrid
            wide={true}
            label={<Label className="requiredField">Store Handle</Label>}
            input={
              <Input
                isError={errors.store_handle?.message ? true : false}
                type={'text'}
                placeholder={'Store Handle'}
                disabled={isConnected}
                {...register('store_handle', {
                  required: { value: true, message: 'Store Handle harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.store_handle && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_handle.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ButtonReauthorization {...{
              isConnected,
              form: 'shopline_form'
            }} />
            <ButtonAuthorization {...{
              form: 'shopline_form',
              disable: isConnected,
            }} />
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default ShoplineContent;
